import React, {Component} from "react";
import {Button, Form, Input, Select} from "antd";
import { MinusCircleOutlined, PlusOutlined} from "@ant-design/icons";
const {Option} = Select;

const formItemLayoutWithOutLabel = {
    labelCol: {
        xs: { span: 24 },
        sm: { span: 8,offset:2 },
    },
    wrapperCol: {
        xs: { span: 20 },
        sm: { span: 10 },
    },
};
class ServiceSoftwareCancellation extends Component{
    constructor(props) {
        super(props);
    }
    render() {
        return <Form.List name="template1">
            {(fields, { add, remove }) => (
                <>
                    <Form.Item
                        className={'addFormBtn'}
                        label="Claim Details"
                    >
                        <Button className={'addBtn'} onClick={() => {add()}} type="dashed" icon={<PlusOutlined />}>

                        </Button>
                    </Form.Item>
                    {this.props.InvoiceClaimMsg?
                        <div>
                            {fields.sort(function (a, b) {
                                return b.name - a.name;
                            }).map(({ key, name, fieldKey, field, index, ...restField }) => (
                                <div key={key} className="spaceBox">
                                    <Form.Item
                                        {...formItemLayoutWithOutLabel}
                                        label="Invoice Number"
                                        {...restField}
                                        name={[name,'invoiceNumber']}
                                        fieldKey={[fieldKey, 'invoiceNumber']}
                                        rules={[{ required: true }]}
                                    >
                                        <Input maxLength={10} />
                                        <MinusCircleOutlined onClick={() => {
                                            remove(name)
                                            this.props.deleteData(name)
                                        }}/>
                                    </Form.Item>
                                    <Form.Item
                                        label="Invoice Item Number"
                                        {...restField}
                                        name={[name, 'invoiceItemNo']}
                                        fieldKey={[fieldKey, 'invoiceItemNo']}
                                        rules={[{ required: false}]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    {this.props.epackTypeKey==2?
                                        <Form.Item
                                            label="DOA Period Confirmation Number"
                                            {...restField}
                                            name={[name, 'doaConfirmNo']}
                                            fieldKey={[fieldKey, 'doaConfirmNo']}
                                            rules={[{ required: true}]}
                                        >
                                            <Input maxLength={10} />
                                        </Form.Item>:''
                                    }
                                    <Form.Item
                                        label="Part Number"
                                        {...restField}
                                        name={[name, 'partNumber']}
                                        fieldKey={[fieldKey, 'partNumber']}
                                        rules={[{ required: true }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label="Quantity"
                                        {...restField}
                                        name={[name, 'quantity']}
                                        fieldKey={[fieldKey, 'quantity']}
                                        rules={[{ required: true }]}
                                        onChange={(e)=>{
                                            this.props.onCreditAmountTotal(e,name)
                                        }}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label="Credit Amount Per Unit"
                                        {...restField}
                                        name={[name, 'creditAmountUnit']}
                                        fieldKey={[fieldKey, 'creditAmountUnit']}
                                        rules={[{ required: false }]}
                                        onChange={(e)=>{
                                            this.props.onCreditAmountTotal(e,name)
                                        }}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label="Currency"
                                        {...restField}
                                        name={[name, 'currency']}
                                        fieldKey={[fieldKey, 'currency']}
                                        rules={[{ required: true }]}
                                    >
                                        <Select placeholder='Please select'>
                                            {
                                                this.props.currencyList.map((item)=>{
                                                    return <Option value={item.key} >{item.value}</Option>
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            ))}
                        </div>
                        :
                        <div>
                            {fields.sort(function (a, b) {
                                return b.name - a.name;
                            }).map(({ key, name, fieldKey, field, index, ...restField }) => (
                                <div key={key} className="spaceBox">
                                    <Form.Item
                                        {...formItemLayoutWithOutLabel}
                                        label="Invoice Number"
                                        {...restField}
                                        name={[name,'invoiceNumber']}
                                        fieldKey={[fieldKey, 'invoiceNumber']}
                                        rules={[{ required: true }]}
                                    >
                                        <Input maxLength={10} fieldKey={name} onPressEnter={this.props.οnKeyPress} suffix={<div>
                                            <Button type="primary" onClick={this.props.ModalVisible}>Validate</Button>
                                            <MinusCircleOutlined onClick={() => {
                                                remove(name)
                                                this.props.deleteData(name)
                                            }}/>
                                        </div>}/>
                                    </Form.Item>
                                    <Form.Item
                                        label="Sold To"
                                        {...restField}
                                        name={[name, 'soldToNumber']}
                                        fieldKey={[fieldKey, 'soldToNumber']}
                                        rules={[{ required: true}]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                    {this.props.epackTypeKey==2?
                                        <Form.Item
                                            label="DOA Period Confirmation Number"
                                            {...restField}
                                            name={[name, 'doaConfirmNo']}
                                            fieldKey={[fieldKey, 'doaConfirmNo']}
                                            rules={[{ required: true}]}
                                        >
                                            <Input maxLength={10} />
                                        </Form.Item>:''
                                    }
                                    <Form.Item
                                        label="PO Number"
                                        {...restField}
                                        name={[name, 'poNumber']}
                                        fieldKey={[fieldKey, 'poNumber']}
                                        rules={[{ required: true}]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                    {/*<Form.Item*/}
                                    {/*    label="Delivery Number"*/}
                                    {/*    {...restField}*/}
                                    {/*    name={[name, 'DeliveryNumber']}*/}
                                    {/*    fieldKey={[fieldKey, 'DeliveryNumber']}*/}
                                    {/*    rules={[{ required: true}]}*/}
                                    {/*>*/}
                                    {/*    <Input disabled />*/}
                                    {/*</Form.Item>*/}
                                    {/*<Form.Item*/}
                                    {/*    label="Order Number"*/}
                                    {/*    {...restField}*/}
                                    {/*    name={[name, 'Order Number']}*/}
                                    {/*    fieldKey={[fieldKey, 'Order Number']}*/}
                                    {/*    rules={[{ required: true}]}*/}
                                    {/*>*/}
                                    {/*    <Input disabled />*/}
                                    {/*</Form.Item>*/}
                                    <Form.Item
                                        label="Part Number"
                                        {...restField}
                                        name={[name, 'partNumber']}
                                        fieldKey={[fieldKey, 'partNumber']}
                                        rules={[{ required: true }]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                    <Form.Item
                                        label="Quantity"
                                        {...restField}
                                        name={[name, 'quantity']}
                                        fieldKey={[fieldKey, 'quantity']}
                                        rules={[{ required: true }]}
                                        onChange={(e)=>{
                                            this.props.onCreditAmountTotal(e,name)
                                        }}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label="Credit Amount Per Unit"
                                        {...restField}
                                        name={[name, 'creditAmountUnit']}
                                        fieldKey={[fieldKey, 'creditAmountUnit']}
                                        rules={[{ required: false }]}
                                        onChange={(e)=>{
                                            this.props.onCreditAmountTotal(e,name)
                                        }}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label="Credit Amount Total"
                                        {...restField}
                                        name={[name, 'creditAmountTotal']}
                                        fieldKey={[fieldKey, 'creditAmountTotal']}
                                        rules={[{ required: false }]}
                                    >
                                        <Input disabled />
                                    </Form.Item>
                                    <Form.Item
                                        label="Currency"
                                        {...restField}
                                        name={[name, 'currency']}
                                        fieldKey={[fieldKey, 'currency']}
                                        rules={[{ required: true }]}
                                    >
                                        <Select placeholder='Please select'>
                                            {
                                                this.props.currencyList.map((item)=>{
                                                    return <Option value={item.key} >{item.value}</Option>
                                                })
                                            }
                                        </Select>
                                    </Form.Item>
                                </div>
                            ))}
                        </div>
                    }
                </>
            )}
        </Form.List>
    }
}

export default ServiceSoftwareCancellation;